import { MenuDefinition, menuItems } from "../constants/MenuConstants";

// returns all routes which have a resolver
// these routes are used to define react-router items
export function getRoutesWithResolvers(): MenuDefinition[] {
    return menuItems
        .map((m) => {
            return [...(m.children ?? []), m];
        })
        .reduce((i, j) => {
            return i.concat(j);
        }, [])
        .filter((m) => m.componentResolver);
}

// returns items that are shown in the app bar
export function getAppBarItemsForSize(size: string): MenuDefinition[] {
    return menuItems
        .filter((i) => i.displayMode?.appBar.includes(size))
        .filter((i) => i.display)
        .map((i) => {
            return { ...i, children: i.children?.filter((c) => c.display) };
        });
}

// returns items that are shown in the drawer
export function getDrawerItemsForSize(size: string): MenuDefinition[] {
    let items: MenuDefinition[] = [];

    for (let i of menuItems.filter((i) =>
        i.displayMode?.drawer.includes(size)
    )) {
        items.push(i);
    }

    return items
        .filter((i) => i.display)
        .map((i) => {
            return { ...i, children: i.children?.filter((c) => c.display) };
        });
}

// returns items that are shown in the user-menu
export function getUserMenuItemsForSize(size: string): MenuDefinition[] {
    return menuItems.filter((i) => i.displayMode?.userMenu.includes(size));
}
